import { useMutation } from "react-query";
import closeSN from "../services/closeSN";

function useCloseSNMutation() {
  return useMutation(["closeSN"], closeSN);
}

export default useCloseSNMutation;
